export default __webpack_public_path__ + "static/media/imgActivity8-4.9a184bd8.png";